import { render } from "./ModalAsideBottom.vue?vue&type=template&id=247e1ea7&scoped=true"
const script = {}

import "./ModalAsideBottom.vue?vue&type=style&index=0&id=247e1ea7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247e1ea7"]])

export default __exports__